import { apiRequest } from '../../services/apiClient';

// 포트폴리오(G-WORKS 작업물) 분야. 작업물 원본 폴더(portfolio/01~06) 구성을 따른다 (08_파트너사는 회사소개 협력사용이라 제외)
// 서버 worksMapper.js 의 WORKS_CATEGORIES 와 같은 값을 유지한다
export const WORKS_CATEGORIES = [
  { id: 'branding', label: '브랜딩' },
  { id: 'editorial', label: '편집 디자인' },
  { id: 'package', label: '패키지 디자인' },
  { id: 'signage', label: '브랜딩+사인물' },
  { id: 'video', label: '영상 작업' },
  { id: 'character', label: '캐릭터 디자인' },
] as const;

export type WorksCategory = (typeof WORKS_CATEGORIES)[number]['id'];

export function worksCategoryLabel(category: string): string {
  return WORKS_CATEGORIES.find((c) => c.id === category)?.label ?? category;
}

export interface WorksItem {
  id: number;
  category: WorksCategory;
  title: string;
  clientName: string | null;
  description: string;
  imageUrl: string;
  createdAt: string;
}

export interface AdminWorksItem extends WorksItem {
  sortOrder: number;
  isPublished: boolean;
}

export interface WorksItemInput {
  category: WorksCategory;
  title: string;
  clientName: string;
  description: string;
  isPublished: boolean;
}

export function fetchWorks(): Promise<WorksItem[]> {
  return apiRequest<WorksItem[]>('/api/works');
}
